import template from './loansRepayment.html';
import controller from './loansRepayment.controller';
import './loansRepayment.scss';

let loansRepaymentComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default loansRepaymentComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepayment.component.js